import React,{useEffect,Fragment}from 'react';
import OmInputFieldWrapper from '../forms/OmInputFieldWrapper';
import { Helmet } from 'react-helmet';
import OmDropdownField from '../forms/OmDropdownField';
import OmButton from '../forms/OmButton';
//import PriceGraphHowToDownloadModal from './PriceGraphHowToDownloadModal'
import { setEndDateValue, setFundValue, setStartDateValue, getFundsListAction, getFundDataAction } from '@om/redux/actions/publicWeb/priceGraph';
import {getSelectedFund, getStartDate, getEndDate, getPriceGraphFormValid, getFundsList, getFundData, getNoFundMsg, getShowFailMsg} from '@om/redux/selectors/publicWeb/priceGraph';
import {useDispatch, useSelector} from 'react-redux';
import {createStructuredSelector} from 'reselect';
import { ThemeContext } from '../../context/ThemeContext';
import './PriceGraph.scss';
//import { hideChatBot } from '@om/redux/actions/publicWeb/chatBot';

const PriceGraph = ({
    slot
}) => {
    const theme = React.useContext(ThemeContext);
    let dispatch = useDispatch();
    const {
        selectedFund,
        startDate,
        endDate,
        formStatus,
        fundsList,
        fundData,
        noFundMsg,
        showFailMsg
    }  = useSelector(
        createStructuredSelector({
            selectedFund: getSelectedFund,
            startDate: getStartDate,
            endDate: getEndDate,
            formStatus: getPriceGraphFormValid,
            fundsList : getFundsList,
            fundData : getFundData,
            noFundMsg: getNoFundMsg,
            showFailMsg: getShowFailMsg
        })
    );
    useEffect(() => {
        dispatch(getFundsListAction());
    }, []);

    useEffect(() => {
        const params = new URLSearchParams(document.location.search.substring(1));
        const fundId = params.get('fundId') || null;
        let value = {
            detail: {
                id: fundId
            }
        }
        if (fundId && fundData.length === 0) {
            dispatch(setFundValue(value));
            dispatch(getFundDataAction());
        }
    }, []);

    useEffect(() => {

        if(google && google.charts) {
            google.charts.load('current', {'packages':['corechart']});
            if(fundData && fundData.length > 0) {
                google.charts.setOnLoadCallback(drawChart);
            }
        }
        function drawChart() {
            let data;
            data = new google.visualization.DataTable();
            data.addColumn('string', 'Date');
            data.addColumn('number', 'Sell Price (cents)');
            data.addRows(fundData);
            var options = {
                legend: { position: 'left' },
                colors: ['#50b848'],
                showAxisLines: true,
                showCategoryLabels: true,
                showValueLabels: true,
                backgroundColor: 'white',
                chartArea : {
                    width : '67%'
                },
                vAxis: {
                    title: 'Sell price (cents)',
                    titleTextStyle : {
                        color: 'black',
                        bold: true,
                        italic: false
                    },
                    textStyle : {
                        fontSize: 14,
                        bold: true,
                    }
                },
                hAxis: {
                    slantedText: true,
                    slantedTextAngle: 90
                },
                tooltip : {
                    isHtml: true
                }
            };
            var chart = new google.visualization.LineChart(document.getElementById('graph_here'));
            chart.draw(data, options);
        }
    }, [dispatch,fundData, selectedFund]);

    return <Fragment>
        <Helmet>
            <script type='text/javascript' src='https://www.gstatic.com/charts/loader.js'></script>
        </Helmet>
        <div slot={slot} className={`${theme} om-price-graph`}>
            <OmDropdownField
                useNativeMobileDropdown={true}
                className='dropdown'
                required='true'
                size='small'
                form-id='priceGraph'
                placeholder='Select your Fund'
                name='fund'
                label='Fund name'
                align='left'
                onSelectHandler={value => dispatch(setFundValue(value))}
                reduxValue={selectedFund}
                options={
                    fundsList && fundsList.map(option => ({value: option.FundId, label: option.FundName}))
                }
            />
            <div className='start-date'>
                <OmInputFieldWrapper
                    labelAlwaysShow={true}
                    label='Start date'
                    placeholder='dd/mm/yyyy'
                    required='true'
                    keyboardMode='numeric'
                    mask='date'
                    reduxValue={startDate}
                    persistHandler={value => dispatch(setStartDateValue(value))}
                />
            </div>

            <div className='end-date'>
                <OmInputFieldWrapper
                    labelAlwaysShow={true}
                    label='End date'
                    placeholder='dd/mm/yyyy'
                    required='true'
                    keyboardMode='numeric'
                    validatorType='date'
                    mask='date'
                    reduxValue={endDate}
                    persistHandler={value => dispatch(setEndDateValue(value))}
                />
            </div>
            <OmButton
                size='small'
                text='Update Graph'
                type='primary'
                disabled={!formStatus}
                onClick={() => dispatch(getFundDataAction())}
            />
            <div className={fundData.length > 0 ? 'graph' : 'hidden'} id='graph_here'/>
            {/* <span className={fundData.length > 0 ? 'om-download-button' : 'hidden'}><OmIcon width='25' height='25' iconName='fc_pdf_download' />
                <OmButton
                    type='text'
                    size='small'
                    text='PRINT OR SAVE GRAPH'
                    onClick={() => { window.print() }} />
                <OmOverlayOpener
                    onOnOpen={() => dispatch(hideChatBot())}
                    slot='more-info-button'
                    openingOverlay='price-graph-how-to-download-modal'
                >
                    <OmIcon iconName='help_outline' width='20' height='20' />
                </om-overlay-opener>
            </span>
        <PriceGraphHowToDownloadModal /> */}

            {noFundMsg ?
                <div className='no-funds-block'>
                    <h5 className='no-bottom-margin no-top-margin'>No fund data to show</h5>
                    <h6 className='no-bottom-margin no-top-margin'>Try alternative dates</h6>
                </div> : ''}

            {showFailMsg ?
                <div className='no-funds-block'>
                    <h5 className='no-bottom-margin no-top-margin'>There was a problem fetching fund data</h5>
                    <h6 className='no-bottom-margin no-top-margin'>Please try again</h6>
                </div> : ''}
        </div>
    </Fragment>
}

export default PriceGraph;